import { AEMScenes } from '@as-react/common-types';
import { loadProductGroupReducer } from '../../productGroup/reducers/ProductGroupReducer';
import deliveryPromiseSaga from '../../deliveryPromise/sagas/DeliveryPromiseSaga';
const loadProductGroupModule = (initialData) => ({
    id: (initialData === null || initialData === void 0 ? void 0 : initialData.productGroupId)
        ? `${AEMScenes.PRODUCT_GROUP}_${initialData.productGroupId}`
        : AEMScenes.PRODUCT_GROUP,
    reducerMap: {
        productGroup: loadProductGroupReducer(initialData),
    },
    sagas: [deliveryPromiseSaga],
});
export default loadProductGroupModule;
